export default class PaginatedResult {

    page = 1;
    onPage = 10;
    pagesCount = 0;
    itemsCount = 0;
    items = null;
    labels = null;
    total = 0;

    constructor(data, modelClass) {
        this.page = data.metadata.page;
        this.onPage = data.metadata.on_page;
        this.pagesCount = data.metadata.pages_count;
        this.itemsCount = data.metadata.items_count;
        this.labels = data.metadata.labels;
        this.total = data.metadata.items_count;

        this.items = [];
        data.data.map((item, key) => {
            let row = new modelClass();
            row.fromJSON(item);

            this.items.push(row);
        });
    }

}